<div class="modal" tabindex="-1" role="dialog" style="display: block;">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title text-primary" style="width: 93%; height: 100%;">
                    <i class="fas fa-file-alt icon-header"></i>
                    {{eventLabel}}: {{eventDetails.ViolationName}}
                </h4>
                <button type="button" class="btn hover-coursor" (click)="closePopup()">
                    <i class="fal fa-times p-2" aria-hidden="true" data-bs-toggle="tooltip" data-bs-placement="top"
                        title="{{closeLabel}}">
                    </i>
                </button>
            </div>
            <div class="modal-body mx-2 px-3 custom-area contant-box-h">
                <div style="width:100%;height:170px;overflow-y: auto;margin-top: 10px;">
                    <div class="modal-body mx-2 px-3 custom-area contant-box-h"
                        style="background-color: var(--bs-screen-glance-popup-text-bg);border-radius: 10px;margin-bottom: 10px;"
                        *ngIf="eventDetails.ScreenGlanceDetails != null">
                        <div style="width:100%;display: flex; justify-content: flex-start;margin: 5px 0px;"
                            *ngIf="eventDetails.ScreenGlanceDetails.SessionId != null">
                            <span style="font-weight: bold;">{{sessionIdLabel}}:&nbsp;</span>
                            <span>{{eventDetails.ScreenGlanceDetails.SessionId}}</span>
                            <span style="margin-left: 10px; cursor: pointer; position: relative;"
                                (click)="copyText(eventDetails.ScreenGlanceDetails.SessionId)" data-bs-toggle="tooltip"
                                data-bs-placement="top" title="{{copyToClipBoard}}">
                                <i class="fas fa-copy copy-icon"></i>
                                <span *ngIf="showCopiedTooltip" class="copied-tooltip">{{copiedText}}</span>
                            </span>
                        </div>
                        <div style="width:100%;display: flex; justify-content: flex-start;margin: 5px 0px;"
                            *ngIf="eventDetails.ScreenGlanceDetails.Initiator != null">
                            <span style="font-weight: bold;">{{initiatorLabel}}:&nbsp;</span>
                            <span>{{eventDetails.ScreenGlanceDetails.Initiator}}</span>
                        </div>
                        <div style="width:100%;display: flex; justify-content: flex-start;margin: 5px 0px;"
                            *ngIf="eventDetails.ScreenGlanceDetails.CreatedDateTime != null">
                            <span style="font-weight: bold;">{{timestampLabel}}:&nbsp;</span>
                            <span>{{formatDateTime(eventDetails.ScreenGlanceDetails.CreatedDateTime) | date :
                                'short'}}</span>
                        </div>
                        <div style="width:100%;display: flex; justify-content: flex-start;margin: 5px 0px;"
                            *ngIf="eventDetails.ScreenGlanceDetails.EndReason != null && eventDetails.ScreenGlanceDetails.EndReason !== ''">
                            <span style="font-weight: bold;">{{reasonLabel}}:&nbsp;</span>
                            <span>{{eventDetails.ScreenGlanceDetails.EndReason}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer py-2">
                <div class="w-100">
                </div>
                <div>
                    <div>
                        <button type="button" class="btn button-danger mx-1 hover-coursor" (click)="closePopup()">
                            {{closeLabel}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>